import {TwitchVideoEmbed} from 'epic-react-common';
import PropTypes from 'prop-types';
import React from 'react';

export default class SkirmishHeader extends React.PureComponent {
  static propTypes = {
    data: PropTypes.object,
  };

  render() {
    const {data} = this.props;
    const {logo, id, title, subtitle, description} = data;
    return (
      <section className="skirmish-header">
        <div className="container">
          <div className="row">
            <div className="col-xs-12">
              <figure>
                <img src={logo} alt="fortnite Summer Skirmish Series" className="img-responsive" />
              </figure>
            </div>
          </div>
          <div className="row">
            <div className="col-xs-12 col-md-8 col-md-offset-2 text-center">
              <h2>{subtitle}</h2>
              <h1>{title}</h1>
              <div className="copy" dangerouslySetInnerHTML={{__html: description}} />
            </div>
          </div>
          <div className="row">
            <div className="col-xs-12 col-md-10 col-md-offset-1">
              {id ? (
                <div className="streamWrapper">
                  <TwitchVideoEmbed channel={id} />
                </div>
              ) : null}
            </div>
          </div>
        </div>
      </section>
    );
  }
}
